import React from 'react';
// import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingScreen from '../../components/LoadingScreen';

// Placeholder component - to be fully implemented later
const SubscriptionPage = () => {
  const { loading } = useAuth();

  if (loading) {
    return <LoadingScreen message="Loading subscription details..." />;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Subscription Plans</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        {/* Free Plan */}
        <div className="bg-white shadow-md rounded-lg overflow-hidden border border-gray-200">
          <div className="p-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Free Trial</h2>
            <p className="text-3xl font-bold text-gray-900 mb-4">$0<span className="text-lg text-gray-600 font-normal">/month</span></p>
            <p className="text-gray-600 mb-6">Get started with basic features</p>
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <svg className="w-5 h-5 text-green-500 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
                <span>Limited product entries</span>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 text-green-500 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
                <span>Basic financial analysis</span>
              </li>
              <li className="flex items-start text-gray-400">
                <svg className="w-5 h-5 text-gray-400 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
                <span>Advanced pitch deck features</span>
              </li>
            </ul>
            <button className="w-full btn-primary-outline" disabled>
              Current Plan
            </button>
          </div>
        </div>
        
        {/* Premium Plan */}
        <div className="bg-white shadow-md rounded-lg overflow-hidden border-2 border-primary-500 relative">
          <div className="bg-primary-500 text-white text-center py-1 text-sm font-semibold">
            MOST POPULAR
          </div>
          <div className="p-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Premium</h2>
            <p className="text-3xl font-bold text-gray-900 mb-4">$29<span className="text-lg text-gray-600 font-normal">/month</span></p>
            <p className="text-gray-600 mb-6">Everything you need for product planning</p>
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <svg className="w-5 h-5 text-green-500 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
                <span>Unlimited product entries</span>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 text-green-500 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
                <span>Detailed financial analysis</span>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 text-green-500 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
                <span>Custom pitch deck creation</span>
              </li>
            </ul>
            <button className="w-full btn-primary">
              Subscribe Now
            </button>
          </div>
        </div>
        
        {/* Enterprise Plan */}
        <div className="bg-white shadow-md rounded-lg overflow-hidden border border-gray-200">
          <div className="p-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Enterprise</h2>
            <p className="text-3xl font-bold text-gray-900 mb-4">$99<span className="text-lg text-gray-600 font-normal">/month</span></p>
            <p className="text-gray-600 mb-6">Advanced features for teams</p>
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <svg className="w-5 h-5 text-green-500 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
                <span>Everything in Premium</span>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 text-green-500 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
                <span>Team collaboration</span>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 text-green-500 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
                <span>Priority support</span>
              </li>
            </ul>
            <button className="w-full btn-primary-outline">
              Contact Sales
            </button>
          </div>
        </div>
      </div>
      
      <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 mb-8">
        <h2 className="text-lg font-semibold text-gray-900 mb-2">Subscription Details</h2>
        <p className="text-gray-600 mb-2">Current Plan: <span className="font-medium">Free Trial</span></p>
        <p className="text-sm text-gray-500">
          Subscription functionality coming soon.
        </p>
      </div>
    </div>
  );
};

export default SubscriptionPage; 